/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title='' }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  );
  
  const metaDescription = description && description !== '' ? description : site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
        class: typeof window === 'undefined' ? 'no-js' : null,
      }}
      title={title}
      titleTemplate={`${site.siteMetadata.title} | %s`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
      ].concat(meta)}
      script={[{
        type: 'text/javascript',
        innerHTML: 'document.documentElement.removeAttribute("class")',
      },{
        async: true,
        src: 'https://infos.prelead.fr/source.js',
      },{
        innerHTML: `
          var loc=document.location.href;
          function pldHist(){pldStack.push(arguments)}
          window.pldStack=window.pldStack||[],(window.pldHist=pldHist)("head",new Date().getTime())
          if (!window.gtag) function gtag() { console.log('Gtag', arguments); } 
        `
      }]}
    />
  )
}

SEO.defaultProps = {
  lang: `fr`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
}

export default SEO
